import styled from "styled-components";

export const ReleaseNotesPageWrapper = styled.div`
  width: 100%;
  padding: 60px 40px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ReleaseNotesContainer = styled.div`
  width: 100%;
  max-width: 800px;
  background-color: ${({ theme }) => theme.white};
  padding: 30px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: 4px;
`;

export const ReleaseNotesTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.blueDark};
`;

export const QuarterHeader = styled.h2`
  font-size: 24px;
  font-weight: 700;
  margin-top: 24px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.blueDark};
  border-bottom: 1px solid ${({ theme }) => theme.neutral200};
  padding-bottom: 8px;
`;

export const QuarterSection = styled.div`
  margin-bottom: 32px;
`;

export const QuarterContent = styled.p`
  line-height: 1.1;
  color: ${({ theme }) => theme.greyDark};
  margin-bottom: 24px;
  text-align: justify;
`;
